import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ComponentLoader, Table } from 'cat-ecommerce-alloy';
import { packageQuantityMapping } from '../../constants';
import { getCustomRenderers } from '../utils';
import ExceptionFeedback from '../../../../../../common/Exception/ExceptionFeedback';
import AvailabilityHeader from '../../common/ColumnHeaders/AvailabilityHeader';
import TotalPriceHeader from '../../common/ColumnHeaders/TotalPriceHeader';
import QuantityHeader from '../../common/ColumnHeaders/QuantityHeader';
import UpdateCartQuantitiesButton from '../../common/UpdateCartQuantitiesButton';

const PackageQuantityTable = () => {
  const orderExtendAttribute = useSelector(
    s => s.orders.byId[s.orders.current]?.orderExtendAttribute
  );
  const {
    currencyNotation: currency,
    includeGST,
    showGST
  } = useSelector(s => s.orders);

  const isUpdateCartQuantitiesDisabled = useSelector(
    s => s.orders.isUpdateCartQuantitiesDisabled
  );
  const isPackageTableLoading = useSelector(
    s => s.orders.isPackageTableLoading
  );

  const ascendingOrderItems = useSelector(
    s => s.orders.byId[s.orders.current]?.ascendingOrderItems || []
  );
  const packageQtyData = ascendingOrderItems.map(item => ({
    ...item,
    isDeleted: !item.packageError
  }));

  const [t] = useTranslation();

  const getLabels = mapping =>
    mapping.map(col => {
      if (col.id === 'delete') {
        return { ...col };
      }

      if (col.id === 'quantity') {
        return {
          ...col,
          label: <QuantityHeader translationKey={col.translationKey} />
        };
      }
      if (col.id === 'availability') {
        return {
          ...col,
          label: (
            <AvailabilityHeader
              translationKey={col.translationKey}
              isQuantityMergeEnabled={
                orderExtendAttribute?.isQuantityMergeEnabled
              }
            />
          )
        };
      }

      if (col.id === 'totalPrice') {
        return {
          ...col,
          label: (
            <TotalPriceHeader
              currency={currency}
              translationKey={col.translationKey}
              includeGST={includeGST}
              showGST={showGST}
              isQuantityMergeEnabled={
                orderExtendAttribute?.isQuantityMergeEnabled
              }
            />
          )
        };
      }
      return {
        ...col,
        label: col.translationKey ? t(col.translationKey) : col.label || ''
      };
    });

  const schema = getLabels(packageQuantityMapping);

  return (
    <div className="pb-4 position-relative">
      {isPackageTableLoading && <ComponentLoader />}
      <div className="mb-3 mt-3" data-testid="package-quantity-table">
        <ExceptionFeedback preventScroll title={t('PACKAGE_QUANTITY_ERROR')}>
          <p>{t('PACKAGE_QUANTITY_ERROR_MSG')}</p>
        </ExceptionFeedback>
      </div>
      <Table
        schema={schema}
        data={packageQtyData}
        customRenderers={getCustomRenderers()}
        className={'col-12 mt-3 mb-3'}
      />
      <div>
        <UpdateCartQuantitiesButton
          isUpdateCartQuantitiesDisabled={isUpdateCartQuantitiesDisabled}
        />
      </div>
    </div>
  );
};

export default PackageQuantityTable;
